import { Box, Tabs, TabList, Tab, TabPanel, ListItemDecorator } from "@mui/joy";

interface ITabItem {
    name: string;
    icon?: any;
    component?: any;
}

interface INavigationProps {
    tabList: ITabItem[];
    defaultValue?: string | number;
}

export function Navigation({ tabList, defaultValue }: INavigationProps) {
    const initial = defaultValue ?? tabList?.[0]?.name ?? 0;
    return (
        <Box sx={{ width: "100%" }}>
            <Tabs
                defaultValue={initial}
                size="sm"
                orientation="vertical"
                sx={{
                    width: "100%",
                    bgcolor: "transparent",
                    "& .MuiTabs-indicator": { display: "none" },
                }}
            >
                <TabList
                    variant="soft"
                    sx={{
                        borderRadius: "8px",
                        p: 0.5,
                        gap: 0.5,
                        bgcolor: "background.level1",
                        width: 200,
                        minWidth: 200,
                        flexShrink: 0,
                        height: "100%",
                        "& button": { justifyContent: "flex-start", minHeight: 32, borderRadius: 6 },
                        "& button[aria-selected='true']": {
                            fontWeight: 600,
                            borderRight: "3px solid",
                            "&::after": { width: 0 },
                        },
                    }}
                >
                    {tabList?.map((t) => (
                        <Tab key={t.name} value={t.name}>
                            {t.icon && <ListItemDecorator>{t.icon}</ListItemDecorator>}
                            {t.name}
                        </Tab>
                    ))}
                </TabList>
                {tabList?.map((t) => (
                    <TabPanel key={t.name} value={t.name} sx={{ p: 0, ml: 3 }}>
                        {t.component}
                    </TabPanel>
                ))}
            </Tabs>
        </Box>
    );
}
